export let ApprovalMethodDateType = /*#__PURE__*/function (ApprovalMethodDateType) {
  ApprovalMethodDateType["Auto"] = "auto";
  ApprovalMethodDateType["Manual"] = "manual";
  return ApprovalMethodDateType;
}({});
export class ApprovalMethodDateModel {
  static fromDTO(dto) {
    return new ApprovalMethodDateModel(dto);
  }
  static makeAuto(approveDate) {
    return new ApprovalMethodDateModel({
      type: ApprovalMethodDateType.Auto,
      auto: {
        approveDate
      }
    });
  }
  static makeManual() {
    return new ApprovalMethodDateModel({
      type: ApprovalMethodDateType.Manual
    });
  }
  constructor(data) {
    this.data = data;
  }
  isAutoApproval() {
    return this.data.type === ApprovalMethodDateType.Auto;
  }
  autoApprovalDate() {
    return this.data.type === ApprovalMethodDateType.Auto ? new Date(this.data.auto.approveDate) : null;
  }
  toDTO() {
    return this.data;
  }
}